import { Component } from 'src/utils';

import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import ccdelete from './../../../images/cc-del.jpg';
import ccedit from './../../../images/cc-edit.jpg';
import template from './cards-management.html';

@Component({
  controllerAs: 'cardManage',
  template
})

export default class CardDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$uibModal',
    'APP',
    '$window'
  ];

  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $uibModal, APP, $window) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.ccdelete = ccdelete;
    this.ccedit = ccedit;
    this.$uibModal = $uibModal;
    this.showHeartLandPage = false;
    this.$spinner = $spinner;
    this.heartand_Approval = "APPROVAL";
    $spinner.show('appSpinner');
    this.updateOrAddCardAllowed = true;
    $auth.getUserProfile().then(success => {
      console.log("state.auth.profile",success);
      var userProfile = success.data;
      if(userProfile.store.paymentType!==this.APP.ORDER.PAYMENT_TYPE.heartLand &&
        userProfile.store.paymentType!==this.APP.ORDER.PAYMENT_TYPE.tsys &&
        userProfile.store.paymentType!==this.APP.ORDER.PAYMENT_TYPE.moneris) {
          this.updateOrAddCardAllowed=false;
        } else {
          this.updateOrAddCardAllowed = true;
        }
    });

    $order.getPaymentInfo()
      .then(success => 
        {
          if(success.data && success.data.length>0) {
            this.cardId = success.data[0].id;
          }
        })
      .finally(() => $spinner.hide('appSpinner'));
    this.init();
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      cardInfo: state.order.paymentInfo
      };
    }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  init() {
    if (this.$stateParams.status === 'Success') { this.$toaster.pop('success', 'Card Details Updated Successfully'); }
    if (this.$stateParams.status === 'Failed') { this.$toaster.pop('success', 'Card detail not  updated. Please try again later.'); }

  }
  submit() {
    if (!this.cardId) {
      this.$toaster.pop('success', 'Please select Card to continue.');
      return;
    }
    let cardNumber = this.cardInfo.filter(card => card.id === this.cardId)[0].cardNumber;
    this.isCallingAPI = true;
    var giftCardsRequest = [];
    var data = {
      "getGiftCardPreAuthCardRequestList": giftCardsRequest
    };
    this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, data)
      .then(
        success => {
          if (success.data.successCode === '0' && success.data.message === 'Approved') {
            this.$state.go('payment.success', {
              orderId: this.$stateParams.orderId,
              isCardSaved: true
            });
          }
          else {
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              reasonCode: success.data.successCode
            });
          }
        },
        error => this.$state.go('payment.failure', {
          orderId: this.$stateParams.orderId,
          reasonCode: error.data.successCode
        })
      )
      .finally(() => this.isCallingAPI = false);
  }

  paymentByNewCard() {
    let device = this.getDeviceParameter();
    this.isCallingAPI = true;
    var giftCardsRequest = [];
    var data = {
      "getGiftCardPreAuthCardRequestList": giftCardsRequest
    };
    this.$order.initializePayment(this.$stateParams.orderId, device, data)
      .then(
        success => {
          if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
            this.$toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
            return;
          }
          this.goToMerchantPage(success.data);
        },
        err => {
          this.$toaster.pop('success', err.data.message);
          this.isCallingAPI = false;
        }
      );
  }

  /*  goToMerchantPage(data, method) {
      method = method || 'post';
  
      let form = document.createElement('form');
      form.setAttribute('method', method);
      form.setAttribute('action', data.message);
  
      let payIdField = document.createElement('input');
      payIdField.setAttribute('type', 'hidden');
      payIdField.setAttribute('name', 'PaymentID');
      payIdField.setAttribute('value', data.additionalInfo);
      form.appendChild(payIdField);
  
      let returnMethodField = document.createElement('input');
      returnMethodField.setAttribute('type', 'hidden');
      returnMethodField.setAttribute('name', 'ReturnMethod');
      returnMethodField.setAttribute('value', 'POST');
      form.appendChild(returnMethodField);
  
      document.body.appendChild(form);
      form.submit();
    }*/
  removeCard(id) {

    var $ctrl = this;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5>Remove Card</h5></div>' +
        '<div class="modal-body" id="modal-body">' +
        '<h6>Are you sure?</h6>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' +
        '</div>',
      controller: ['$scope', '$state', 'orderService', '$uibModalInstance',
        function ($scope, $state, $order, $uibModalInstance) {
          $scope.ok = () => {
            $order.removeCreditCard(id).then(
              success => {
                $ctrl.$toaster.pop('success', success.data.message); $order.getPaymentInfo()
                  .then(success => $ctrl.cardId = success.data[0].id);
              },
              err => {
                $ctrl.$toaster.pop('success', err.data.message);
                $ctrl.isCallingAPI = false;
              }
            );
            $uibModalInstance.close();
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {

      }
    });

  }
  goToMerchantPage(data, method) {

    // method = method || 'post';

    // let form = document.createElement('form');
    // form.setAttribute('method', method);
    // form.setAttribute('action', data.message);

    // let payIdField = document.createElement('input');
    // payIdField.setAttribute('type', 'hidden');
    // payIdField.setAttribute('name', 'PaymentID');
    // payIdField.setAttribute('value', data.additionalInfo);
    // form.appendChild(payIdField);

    // let returnMethodField = document.createElement('input');
    // returnMethodField.setAttribute('type', 'hidden');
    // returnMethodField.setAttribute('name', 'ReturnMethod');
    // returnMethodField.setAttribute('value', 'POST');
    // form.appendChild(returnMethodField);

    // document.body.appendChild(form);
    // form.submit();

  }

  addCard() {
    let device = this.getDeviceParameter();
    var $ctrl = this;
    if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.heartLand) {
      $ctrl.callHeartLandCustom(null, device);
    } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.tsys) {
      // $ctrl.callTsysCustom(id, device);
      $ctrl.callHeartLandCustom(null, device);
    } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.moneris) {
      // $ctrl.callTsysCustom(id, device);
      $ctrl.callMonerisCustom(null, device);
    }
    else {
      $ctrl.$order.updateCreditCard(null, device).then(
        success => {
          if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
            return;
          }
          $ctrl.goToMerchantPage(success.data);
        },
        err => {
          $ctrl.$toaster.pop('success', err.data.message);
          $ctrl.isCallingAPI = false;
        }
      );
    }
  }



  updateCard(id) {
    let device = this.getDeviceParameter();
    // console.log("Here _-----------");
    var $ctrl = this;
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-header modalheaderbg btn-primary"><h5>Update Card</h5></div>' +
        '<div class="modal-body" id="modal-body">' +
        '<h6>Are you sure?</h6>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn " type="button" ng-click="cancel()" style="float: left;">Cancel</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" style="float: right;">OK</button>' +
        '</div>',
      controller: ['$scope', '$state', 'orderService', '$uibModalInstance',
        function ($scope, $state, $order, $uibModalInstance) {
          $scope.ok = () => {

            if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.heartLand) {
              $ctrl.callHeartLandCustom(id, device);
            } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.tsys) {
              // $ctrl.callTsysCustom(id, device);
              $ctrl.callHeartLandCustom(id, device);
            } else if ($ctrl.profile.store.paymentType === $ctrl.APP.ORDER.PAYMENT_TYPE.moneris) {
              // $ctrl.callTsysCustom(id, device);
              $ctrl.callMonerisCustom(id, device);
            }
            else {
              $ctrl.$order.updateCreditCard(id, device).then(
                success => {
                  if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                    return;
                  }
                  $ctrl.goToMerchantPage(success.data);
                },
                err => {
                  $ctrl.$toaster.pop('success', err.data.message);
                  $ctrl.isCallingAPI = false;
                }
              );
            }
            $uibModalInstance.close();
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ],
      resolve: {

      }
    });

  }
  getDeviceParameter() {
    if (window.innerWidth <= 576) {
      return 'm';
    }
    else if (window.innerWidth > 576 && window.innerWidth <= 768) {
      return 't';
    }
    else if (window.innerWidth > 768) {
      return 'd';
    }
  }

  callHeartLandCustom(id, device) {
    this.showHeartLandPage = true;
    this.$state.go('card-update', { 'cardId': id });
    // this.templateUrl="payment-detail.html";
  }

  callTsysCustom(id, device) {
    this.showHeartLandPage = true;
    this.$state.go('tsyscard-update', { 'cardId': id });
    // this.templateUrl="payment-detail.html";
  } 
  
  callMonerisCustom(id, device) {
    this.showHeartLandPage = true;
    this.$state.go('card-update', { 'cardId': id });
    // this.templateUrl="payment-detail.html";
  } 

}




// WEBPACK FOOTER //
// ./src/app/order/cards-management/cards-management.js